module.exports = "/_next/static/resources/box-ebb02406b3a9d7a1cc333377e9c9f2b4.jpg";